import React from "react";
import { GridLayout } from "./Layouts/Grid";
import { TableLayout } from "./Layouts/Table";
import { StackedLayout } from "./Layouts/Stacked";
import "./CartItems.scss";

export const CartItems = ({ settings }) => {
  const { section } = settings;
  const productLayout = section.product_layout;

  return (
    <div className={`items-layout__${productLayout}`}>
      {productLayout === "table" ? (
        <TableLayout settings={settings} />
      ) : productLayout === "grid" ? (
        <GridLayout settings={settings} />
      ) : (
        <StackedLayout settings={settings} />
      )}
    </div>
  );
};
